import { lt, showSuccessAlert } from '@mews/framework';
import { useRepositoryMutation } from '@mews-commander/data-access';
import { TravelAgencyNumberFormSchema, TravelAgencyNumberFormValues } from './types';

export const useChangeTravelAgencyNumberMutation = (reservationIds: string[]) =>
    useRepositoryMutation('reservations', 'updateChannelNumber', {
        transformParams: (values: TravelAgencyNumberFormValues) => {
            const { channelNumber } = TravelAgencyNumberFormSchema.parse(values);

            return {
                reservationIds,
                channelNumber,
            };
        },
        onSuccess: () => showSuccessAlert({ description: lt('TravelAgencyNumberChangedSuccessMessage') }),
    });
